import { KnowledgeBase, KnowledgeBlock } from '@/models/knowledge'

export interface KnowledgeState {
  bases: KnowledgeBase[]
  blocks: Record<string, KnowledgeBlock[]>
  selectedBaseId?: string
  openSectionIds: string[]
  openBlockIds: string[]
}

export const initialState: KnowledgeState = {
  bases: [],
  blocks: {},
  selectedBaseId: undefined,
  openSectionIds: [],
  openBlockIds: [],
}
